module.exports = __webpack_public_path__ + "static/media/java.ba6f88f7.jpg";